import React from 'react';
import { Button, Dialog, DialogContent, DialogTitle, Box, Typography, Grid, IconButton, Tooltip, DialogActions } from '@mui/material';
import { mdiFileAccount } from '@mdi/js';
import { MdiIcon } from '@components';
export function InfoDialog({ data, onClose, title, ...props }) {
    return (<Dialog {...props} maxWidth='lg' onClose={onClose}>
      <DialogTitle>{title || 'Detalhes'}</DialogTitle>
      <DialogContent>
        {data && data.length > 0 ? (<Box>
            <Grid container spacing={2}>
              {data.map((item, index) => (<Grid item md={item.key === 'Observações' ? 12 : 4} key={index}>
                  <Box sx={{ mb: 2 }}>
                    <Typography sx={{ fontWeight: 'bold' }} variant='subtitle1'>
                      {item.key}
                    </Typography>
                    {['Anexo', 'Ficheiro'].includes(item.key) && item.value ? (<Tooltip title={'Ver ficheiro'} placement='top'>
                        <IconButton color='primary' onClick={() => {
                        window.open(`/api/Upload/crm/download/${item.value}`, '_blank');
                    }}>
                          <MdiIcon path={mdiFileAccount} sx={{ color: '#1976D2' }}/>
                        </IconButton>
                      </Tooltip>) : (<Typography variant='body2' sx={{
                        whiteSpace: item.key === 'Observações' ? 'pre-wrap' : 'normal'
                    }}>
                        {item.value ? item.value.toString() : 'Não tem'}
                      </Typography>)}
                  </Box>
                </Grid>))}
            </Grid>
          </Box>) : (<Typography>Não tem</Typography>)}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {
            onClose();
        }} variant='contained'>
          OK
        </Button>
      </DialogActions>
    </Dialog>);
}
